module.exports = __webpack_public_path__ + "static/img/Frame_01.698d6270.svg";